/** @format */

import { FeedbackDto, Validation } from '../models/requests/FeedbackDto';

/**
 * Flattens API `validation.messages` to `string[]`. Handles a normal
 * `string[]` and legacy double-wrapped arrays.
 */
export const normalizeValidationMessages = (messages: unknown): string[] => {
  if (messages == null) return [];
  if (Array.isArray(messages)) {
    if (messages.length === 0) return [];
    const first = messages[0];
    if (typeof first === 'string') {
      return messages as string[];
    }
    if (Array.isArray(first)) {
      return (messages as unknown[][]).flat() as string[];
    }
    return messages.map((m) => String(m));
  }
  return [String(messages)];
};

export const GetMessageReponse = (
  resp: any,
  showSuccess: boolean,
  responseType: string
) => {
  let feedback: FeedbackDto = {} as FeedbackDto;
  const validate = resp?.validation;
  const validateSystemOut = resp;
  if (!validate && !validateSystemOut?.error) {
    return feedback;
  }

  if (validateSystemOut && validateSystemOut.message) {
    feedback = {
      ...feedback,
      open: true,
      severity: 'error',
      isSuccess: false,
      validation: {
        code: 400,
        messages: [
          'Something went wrong while processing your request. If the problem persists please contact the administrator.',
        ],
      } as Validation,
    };
    return feedback;
  }

  if (resp?.error && responseType.includes('rejected')) {
    if (!validate) {
      feedback = {
        ...feedback,
        open: true,
        severity: 'error',
        isSuccess: false,
        validation: {
          code: 400,
          messages: [
            'Something went wrong while processing your request. If the problem persists please contact the administrator.',
          ],
        } as Validation,
      };
    } else {
      feedback = {
        ...feedback,
        open: true,
        severity: 'error',
        isSuccess: false,
        validation: {
          code: 400,
          messages: [resp.error.message],
        } as Validation,
      };
    }
  } else if (responseType.includes('fulfilled')) {
    if (validate && (validate.code === 200 || validate.code === 201)) {
      feedback = {
        ...feedback,
        open: showSuccess,
        severity: 'success',
        isSuccess: true,
        validation: {
          code: validate.code,
          messages: normalizeValidationMessages(validate.messages),
        } as Validation,
      };
    } else {
      if (validate) {
        feedback = {
          ...feedback,
          open: true,
          severity: 'error',
          isSuccess: false,
          validation: {
            code: validate.code,
            messages: normalizeValidationMessages(validate.messages),
          } as Validation,
        };
      }
    }
  } else if (responseType.includes('rejected')) {
    feedback = {
      ...feedback,
      open: true,
      severity: 'error',
      isSuccess: false,
      validation: {
        code: 400,
        messages: [
          'The request could not be understood by the server, please refactor and try again.',
        ],
      } as Validation,
    };
  }
  return feedback;
};

// 1 - There is an error, 2 - there is a new record created, 3 - there are no issues, the request was successful
export const HasErrors = (action: any): number => {
  const p = action?.payload ?? action;
  const validation = p?.validation ?? p?.Validation;
  if (validation) {
    if (validation?.code === 200) {
      return 3;
    } else if (validation?.code === 201) {
      return 2;
    }
  }
  return 1;
};
